import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../../lib/types";
import { DistinctAirportResponseDTO, filtersReportDTO, findAllReportResponseDTO, GeneratePdfRequestDTO, ReportCreareRequestDTO, ReportDTO, ReportErrorMessage, ReportUpdateDTO } from "./dto";
import { NewReportService } from "./service";

interface ReportState {
    findAllStatus: PromiseStatuses
    findAllResponse?: findAllReportResponseDTO
    findAllFilters: filtersReportDTO
    findByIdStatus: PromiseStatuses
    findByIdResponse?: ReportDTO
    createReportStatus: PromiseStatuses
    createReportRequest: ReportCreareRequestDTO
    createReportErrorMessage: string
    deleteReportStatus: PromiseStatuses
    updateReportStatus: PromiseStatuses
    updateReportRequest: ReportUpdateDTO
    selectedTab: number
    selectedTabAirport: number
    selectedTabWeather: number
    openNewReportModal: boolean
    openDeleteConfirmModal: boolean
    reportId: string
    refreshReportStatus: PromiseStatuses
    distinctAirportsStatus: PromiseStatuses
    distinctAirportsResponse?: DistinctAirportResponseDTO
    selectedTabHistory: number
    generatePdfStatus: PromiseStatuses
    generatePdfRequest: GeneratePdfRequestDTO
    generatePdfResponse?: string
    selectedTabNotam: number
}

const initialState: ReportState = {
    findAllStatus: "idle",
    findByIdStatus: "idle",
    createReportStatus: "idle",
    deleteReportStatus: "idle",
    updateReportStatus: "idle",
    updateReportRequest: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        report: "",
        active_notam: true
    },
    selectedTab: 0,
    selectedTabAirport: 0,
    openNewReportModal: false,
    createReportRequest: {
        user_info: {
            first_name: "",
            last_name: "",
            email: "",
            phone: ""
        },
        flight_ident: "",
        start_date: new Date(),
        end_date: new Date(),
        with_news: false,
        with_notamify: true,
        active_notam: true
    },
    findAllFilters: {
        page: 1,
        pageSize: 20,
        sort: -1,
        sortBy: "",
        flightIdent: "",
        departureAirport: "",
        arrivalAirport: "",
        fromDate: ""
    },
    openDeleteConfirmModal: false,
    reportId: "",
    selectedTabWeather: 0,
    refreshReportStatus: "idle",
    distinctAirportsStatus: "idle",
    selectedTabHistory: 0,
    generatePdfStatus: "idle",
    generatePdfRequest: {
        datas: {
            user_info: {
                first_name: "",
                last_name: "",
                email: "",
                phone: ""
            },
            report: "",
            flight_info: {
                flight: {
                    flight_number: "",
                    ident: "",
                    ident_iata: "",
                    history: {
                        blocked: false,
                        diverted: false,
                        cancelled: false
                    },
                    departure: {
                        airport: {
                            name: "",
                            city: "",
                            code_icao: "",
                            code_iata: "",
                            code_lid: "",
                            timezone: "",
                            timezone_abbr: ""
                        },
                        flight_gate_times: {
                            scheduled_out: new Date(),
                            scheduled_out_tz: new Date(),
                            actual_out: new Date(),
                            actual_out_tz: new Date(),
                            departure_delay: ""
                        },
                        flight_runway_times: {
                            scheduled_off: new Date(),
                            scheduled_off_tz: new Date(),
                            actual_off: new Date(),
                            actual_off_tz: new Date(),
                            runway_delay: ""
                        },
                        terminal_and_gate: {
                            terminal_origin: "",
                            gate_origin: ""
                        },
                        craft_type: {
                            aircraft_type: ""
                        },
                        flight_time: ""
                    },
                    arrival: {
                        airport: {
                            name: "",
                            city: "",
                            code_icao: "",
                            code_iata: "",
                            code_lid: "",
                            timezone: "",
                            timezone_abbr: ""
                        },
                        flight_gate_times: {
                            scheduled_in: new Date(),
                            scheduled_in_tz: new Date(),
                            actual_in: new Date(),
                            actual_in_tz: new Date(),
                            arrival_delay: ""
                        },
                        flight_runway_times: {
                            scheduled_on: new Date(),
                            scheduled_on_tz: new Date(),
                            actual_on: new Date(),
                            actual_on_tz: new Date(),
                            runway_delay: ""
                        },
                        terminal_and_gate: {
                            terminal_destination: "",
                            gate_destination: "",
                            baggage_claim: ""
                        },
                        tail_number: {
                            tail_number: ""
                        },
                        flight_time: ""
                    },
                    aircraft_rotation: [],
                    aircraft_name: "",
                    airline_name: "",
                    filed_ete: 0,
                    operated_by: "",
                    operator_iata: "",
                    operator: ""
                },
                diverted_flight: {
                    flight_number: "",
                    ident: "",
                    ident_iata: "",
                    history: {
                        blocked: false,
                        diverted: false,
                        cancelled: false
                    },
                    departure: {
                        airport: {
                            name: "",
                            city: "",
                            code_icao: "",
                            code_iata: "",
                            code_lid: "",
                            timezone: "",
                            timezone_abbr: ""
                        },
                        flight_gate_times: {
                            scheduled_out: new Date(),
                            scheduled_out_tz: new Date(),
                            actual_out: new Date(),
                            actual_out_tz: new Date(),
                            departure_delay: ""
                        },
                        flight_runway_times: {
                            scheduled_off: new Date(),
                            scheduled_off_tz: new Date(),
                            actual_off: new Date(),
                            actual_off_tz: new Date(),
                            runway_delay: ""
                        },
                        terminal_and_gate: {
                            terminal_origin: "",
                            gate_origin: ""
                        },
                        craft_type: {
                            aircraft_type: ""
                        },
                        flight_time: ""
                    },
                    arrival: {
                        airport: {
                            name: "",
                            city: "",
                            code_icao: "",
                            code_iata: "",
                            code_lid: "",
                            timezone: "",
                            timezone_abbr: ""
                        },
                        flight_gate_times: {
                            scheduled_in: new Date(),
                            scheduled_in_tz: new Date(),
                            actual_in: new Date(),
                            actual_in_tz: new Date(),
                            arrival_delay: ""
                        },
                        flight_runway_times: {
                            scheduled_on: new Date(),
                            scheduled_on_tz: new Date(),
                            actual_on: new Date(),
                            actual_on_tz: new Date(),
                            runway_delay: ""
                        },
                        terminal_and_gate: {
                            terminal_destination: "",
                            gate_destination: "",
                            baggage_claim: ""
                        },
                        tail_number: {
                            tail_number: ""
                        },
                        flight_time: ""
                    },
                    aircraft_rotation: [],
                    aircraft_name: "",
                    airline_name: "",
                    filed_ete: 0,
                    operated_by: "",
                    operator_iata: "",
                    operator: ""
                },
                departures: [],
                arrivals: [],
                departure_airport_weather: {
                    lat: 0,
                    lon: 0,
                    timezone: "",
                    timezone_offset: 0,
                    hourly: []
                },
                arrival_airport_weather: {
                    lat: 0,
                    lon: 0,
                    timezone: "",
                    timezone_offset: 0,
                    hourly: []
                },
                news: {
                    articles: []
                },
                departure_airport_notams: [],
                arrival_airport_notams: []
            }
        }
    },
    createReportErrorMessage: "",
    selectedTabNotam: 0,
}

export const findAllReport = createAsyncThunk(
    "report/findAll",
    async (filters: filtersReportDTO): Promise<findAllReportResponseDTO> => {
        const reportService = NewReportService()

        return reportService.findAllReport(filters)
    }
)

export const findByIdReport = createAsyncThunk(
    "report/findById",
    async (id: string): Promise<ReportDTO> => {
        const reportService = NewReportService()

        return reportService.findByIdReport(id)
    }
)

export const createReport = createAsyncThunk<
    string,
    ReportCreareRequestDTO,
    { rejectValue: { message: string } }
>(
    "report/create",
    async (request, { rejectWithValue }) => {
        const reportService = NewReportService()

        try {
            const result = await reportService.create(request)
            return result
        } catch (err: any) {
            return rejectWithValue({ message: err.response.data })
        }
    }
)

export const deleteReport = createAsyncThunk(
    "report/delete",
    async (id: string): Promise<void> => {
        const reportService = NewReportService()

        return reportService.delete(id)
    }
)

export const updateReport = createAsyncThunk(
    "report/update",
    async (request: { id: string, request: ReportUpdateDTO }): Promise<void> => {
        const reportService = NewReportService()

        return reportService.updateReport(request.id, request.request)
    }
)

export const refreshReport = createAsyncThunk(
    "report/refresh",
    async (id: string): Promise<string> => {
        const reportService = NewReportService()

        return reportService.refresh(id)
    }
)

export const distinctAirports = createAsyncThunk(
    "report/distinctAirports",
    async (): Promise<DistinctAirportResponseDTO> => {
        const reportService = NewReportService()

        return reportService.distinctAirports()
    }
)

export const generatePdf = createAsyncThunk(
    "report/generatePdf",
    async (request: GeneratePdfRequestDTO): Promise<string> => {
        const reportService = NewReportService()

        return reportService.generatePdf(request)
    }
)

const reportSlice = createSlice({
    name: "report/slice",
    initialState,
    extraReducers(builder) {
        builder
            .addCase(findAllReport.pending, (state) => {
                state.findAllStatus = "loading"
            })
            .addCase(findAllReport.fulfilled, (state, action) => {
                state.findAllStatus = "successfully"
                state.findAllResponse = action.payload
            })
            .addCase(findAllReport.rejected, (state) => {
                state.findAllStatus = "failed"
            })
            .addCase(findByIdReport.pending, (state) => {
                state.findByIdStatus = "loading"
            })
            .addCase(findByIdReport.fulfilled, (state, action) => {
                state.findByIdStatus = "successfully"
                state.findByIdResponse = action.payload
            })
            .addCase(findByIdReport.rejected, (state) => {
                state.findByIdStatus = "failed"
            })
            .addCase(createReport.pending, (state) => {
                state.createReportStatus = "loading"
            })
            .addCase(createReport.fulfilled, (state) => {
                state.createReportStatus = "successfully"
            })
            .addCase(createReport.rejected, (state, action) => {
                state.createReportStatus = "failed"
                state.createReportErrorMessage = ReportErrorMessage.get(action.payload?.message!) || "Si è verificato un errore durante la creazione del report.";
            })
            .addCase(deleteReport.pending, (state) => {
                state.deleteReportStatus = "loading"
            })
            .addCase(deleteReport.fulfilled, (state) => {
                state.deleteReportStatus = "successfully"
            })
            .addCase(deleteReport.rejected, (state) => {
                state.deleteReportStatus = "failed"
            })
            .addCase(updateReport.pending, (state) => {
                state.updateReportStatus = "loading"
            })
            .addCase(updateReport.fulfilled, (state) => {
                state.updateReportStatus = "successfully"
            })
            .addCase(updateReport.rejected, (state) => {
                state.updateReportStatus = "failed"
            })
            .addCase(refreshReport.pending, (state) => {
                state.refreshReportStatus = "loading"
            })
            .addCase(refreshReport.fulfilled, (state) => {
                state.refreshReportStatus = "successfully"
            })
            .addCase(refreshReport.rejected, (state) => {
                state.refreshReportStatus = "failed"
            })
            .addCase(distinctAirports.pending, (state) => {
                state.distinctAirportsStatus = "loading"
            })
            .addCase(distinctAirports.fulfilled, (state, action) => {
                state.distinctAirportsStatus = "successfully"
                state.distinctAirportsResponse = action.payload
            })
            .addCase(distinctAirports.rejected, (state) => {
                state.distinctAirportsStatus = "failed"
            })
            .addCase(generatePdf.pending, (state) => {
                state.generatePdfStatus = "loading"
            })
            .addCase(generatePdf.fulfilled, (state, action) => {
                state.generatePdfStatus = "successfully"
                state.generatePdfResponse = action.payload
            })
            .addCase(generatePdf.rejected, (state) => {
                state.generatePdfStatus = "failed"
            })
    },
    reducers: {
        resetReportCreateRequest: (state) => {
            state.createReportRequest = {
                user_info: {
                    first_name: "",
                    last_name: "",
                    email: "",
                    phone: ""
                },
                flight_ident: "",
                start_date: new Date(),
                end_date: new Date(),
                with_news: false,
                with_notamify: true,
                active_notam: true
            }
        },
        setFindAllStatus: (state, action) => {
            state.findAllStatus = action.payload
        },
        setFindByIdStatus: (state, action) => {
            state.findByIdStatus = action.payload
        },
        setCreateReportStatus: (state, action) => {
            state.createReportStatus = action.payload
        },
        setUpdateReportStatus: (state, action) => {
            state.updateReportStatus = action.payload
        },
        setSelectedTab: (state, action) => {
            state.selectedTab = action.payload
        },
        setSelectedTabAirport: (state, action) => {
            state.selectedTabAirport = action.payload
        },
        setOpenNewReportModal: (state, action) => {
            state.openNewReportModal = action.payload
        },
        setCreateReportRequestFlightIdent: (state, action) => {
            state.createReportRequest.flight_ident = action.payload
        },
        setCreateReportRequestStartDate: (state, action) => {
            state.createReportRequest.start_date = action.payload
        },
        setCreateReportRequestEndDate: (state, action) => {
            state.createReportRequest.end_date = action.payload
        },
        setCreateReportRequestFirstName: (state, action) => {
            state.createReportRequest.user_info.first_name = action.payload
        },
        setCreateReportRequestLastName: (state, action) => {
            state.createReportRequest.user_info.last_name = action.payload
        },
        setCreateReportRequestEmail: (state, action) => {
            state.createReportRequest.user_info.email = action.payload
        },
        setCreateReportRequestPhone: (state, action) => {
            state.createReportRequest.user_info.phone = action.payload
        },
        setCreateReportRequestNotam: (state, action) => {
            state.createReportRequest.with_notamify = action.payload
        },
        setReportFilterPage: (state, action) => {
            state.findAllFilters.page = action.payload
        },
        setOpenDeleteConfirmModal: (state, action) => {
            state.openDeleteConfirmModal = action.payload
        },
        setDeleteReportStatus: (state, action) => {
            state.deleteReportStatus = action.payload
        },
        setReportId: (state, action) => {
            state.reportId = action.payload
        },
        setUpdateReportFirstName: (state, action) => {
            state.updateReportRequest.first_name = action.payload
        },
        setUpdateReportLastName: (state, action) => {
            state.updateReportRequest.last_name = action.payload
        },
        setUpdateReportEmail: (state, action) => {
            state.updateReportRequest.email = action.payload
        },
        setUpdateReportPhone: (state, action) => {
            state.updateReportRequest.phone = action.payload
        },
        setUpdateReportReport: (state, action) => {
            state.updateReportRequest.report = action.payload
        },
        setSelectedTabWeather: (state, action) => {
            state.selectedTabWeather = action.payload
        },
        setFilterFlightIdent: (state, action) => {
            state.findAllFilters.flightIdent = action.payload
        },
        setFilterSort: (state, action) => {
            state.findAllFilters.sort = action.payload
        },
        setFilterSortBy: (state, action) => {
            state.findAllFilters.sortBy = action.payload
        },
        setFilterDepartureAirport: (state, action) => {
            state.findAllFilters.departureAirport = action.payload
        },
        setFilterArrivalAirport: (state, action) => {
            state.findAllFilters.arrivalAirport = action.payload
        },
        setFilterReportFromDate: (state, action) => {
            state.findAllFilters.fromDate = action.payload
        },
        setRefreshReportStatus: (state, action) => {
            state.refreshReportStatus = action.payload
        },
        setDistinctAirportsStatus: (state, action) => {
            state.distinctAirportsStatus = action.payload
        },
        setSelectedTabHistory: (state, action) => {
            state.selectedTabHistory = action.payload
        },
        setSelectedTabNotam: (state, action) => {
            state.selectedTabNotam = action.payload
        },
    }
})

export const {
    setFindAllStatus,
    setFindByIdStatus,
    setCreateReportStatus,
    setSelectedTab,
    setSelectedTabAirport,
    setCreateReportRequestEmail,
    setOpenNewReportModal,
    setCreateReportRequestEndDate,
    setCreateReportRequestFirstName,
    setCreateReportRequestFlightIdent,
    setCreateReportRequestLastName,
    setCreateReportRequestPhone,
    setUpdateReportStatus,
    setCreateReportRequestStartDate,
    setReportFilterPage,
    setOpenDeleteConfirmModal,
    setDeleteReportStatus,
    resetReportCreateRequest,
    setReportId,
    setUpdateReportEmail,
    setUpdateReportFirstName,
    setUpdateReportLastName,
    setUpdateReportPhone,
    setUpdateReportReport,
    setSelectedTabWeather,
    setFilterFlightIdent,
    setFilterSort,
    setFilterSortBy,
    setRefreshReportStatus,
    setDistinctAirportsStatus,
    setFilterArrivalAirport,
    setFilterDepartureAirport,
    setFilterReportFromDate,
    setSelectedTabHistory,
    setCreateReportRequestNotam,
    setSelectedTabNotam,
} = reportSlice.actions

export default reportSlice.reducer